import { render } from "./MyRegister_notice.vue?vue&type=template&id=4c3d0289"
import script from "./MyRegister_notice.vue?vue&type=script&lang=js"
export * from "./MyRegister_notice.vue?vue&type=script&lang=js"

import "./MyRegister_notice.vue?vue&type=style&index=0&id=4c3d0289&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__